import { slices } from "@/constants/sliceNames";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios/defaultAxios";
import { errorMessage, successMessage } from "../actions/messages.actions";

const ENDPOINT = "/connectors";
const PROVIDERS_ENDPOINT = "/connectors/providers";

/****** Get Connectors ******/

export const requestConnectors = createAsyncThunk(
  `${slices.connectors}/requestConnectors`,
  async (filters = {}, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`${ENDPOINT}?${new URLSearchParams(filters).toString()}`);
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestConnectorsStatus = {
  [requestConnectors.fulfilled]: (state, action) => {
    state.loading = false;
    state.list = action.payload.data;
    state.pageCount = action.payload.records_count ?? 10;
  },
  [requestConnectors.pending]: (state, action) => {
    state.loading = true;
  },
  [requestConnectors.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Delete Connector ******/

export const requestDeleteConnector = createAsyncThunk(
  `${slices.connectors}/requestDeleteConnector`,
  async (appId, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`${ENDPOINT}/${appId}`);
      dispatch(successMessage(response.data.message));
      return { appId };
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestDeleteConnectorStatus = {
  [requestDeleteConnector.fulfilled]: (state, action) => {
    state.loading = false;
    state.list = state.list.filter((app) => app.id !== action.payload.appId);
  },
  [requestDeleteConnector.pending]: (state, action) => {
    state.loading = true;
  },
  [requestDeleteConnector.rejected]: (state, action) => {
    state.loading = false;
  },
};

/****** Create Connector ******/

export const requestCreateConnector = createAsyncThunk(
  `${slices.connectors}/requestCreateConnector`,
  async (connectorData, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.post(ENDPOINT, connectorData);
      dispatch(successMessage(response.data.message));
      return response.data.data;
    } catch (error) {
      dispatch(errorMessage(error.response?.data?.error ?? error.message));
      return rejectWithValue(error.response?.data?.error ?? error.message);
    }
  }
);

export const requestCreateConnectorStatus = {
  [requestCreateConnector.fulfilled]: (state, action) => {
    state.loading = false;
    state.item = action.payload;
  },
  [requestCreateConnector.pending]: (state, action) => {
    state.loading = true;
  },
  [requestCreateConnector.rejected]: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },
};

export function requestConnectorProviders(onSuccess) {
  return async (dispatch) => {
    return axios.get(PROVIDERS_ENDPOINT).then((res) => {
      onSuccess && onSuccess(res.data.data);
    });
  };
}

export function getSFTPServerHostname() {
  return async (dispatch) => {
    return axios.get(`${ENDPOINT}/sftp/hostname`).then((response) => response.data);
  };
}
